export type SimplePeptideOption = {
  id: string;
  name: string;
  description: string;
  url: string;
  productid: string;
  categories: string[];
};

export const SIMPLE_PEPTIDE_OPTIONS: SimplePeptideOption[] = [
  {
    id: 1,
    name: "AOD 9604 5mg",
    description: "AOD 9604 is a modified fragment of human growth hormone used for fat metabolism and weight management.",
    url: "https://simplepeptide.com/shop/aod-9604-5mg/",
    productId: 1958,
    categories: ["Fat Loss", "Growth Hormone"]
  },
  {
    id: 2,
    name: "Bacteriostatic Water 10ml",
    description: "Sterile bacteriostatic water for peptide reconstitution and medical purposes.",
    url: "https://simplepeptide.com/shop/bacteriostatic-water-10ml/",
    productId: 1525,
    categories: ["Reconstitution", "Accessories"]
  },
  {
    id: 3,
    name: "Bacteriostatic Water 30ml",
    description: "Larger volume of bacteriostatic water for peptide reconstitution.",
    url: "https://simplepeptide.com/shop/bacteriostatic-water-30ml/",
    productId: 28,
    categories: ["Reconstitution", "Accessories"]
  },
  {
    id: 4,
    name: "BPC 157 500mcg 100 Tablets",
    description: "BPC 157 is known for its healing and anti-inflammatory properties, available in tablet form.",
    url: "https://simplepeptide.com/shop/bpc-157-500mcg-100-tablets/",
    productId: 30,
    categories: ["Healing", "Anti-Inflammatory"]
  },
  {
    id: 5,
    name: "BPC 157 5mg",
    description: "BPC 157 peptide for accelerating wound healing and reducing inflammation.",
    url: "https://simplepeptide.com/shop/bpc-157-5mg/",
    productId: 29,
    categories: ["Healing", "Anti-Inflammatory"]
  },
  {
    id: 6,
    name: "BPC 157 + TB-500 5mg+5mg",
    description: "A blend of BPC 157 and TB-500 designed to enhance recovery and repair.",
    url: "https://simplepeptide.com/shop/bpc-157-tb-500-5mg-5mg/",
    productId: 50,
    categories: ["Healing", "Anti-Inflammatory", "Recovery"]
  },
  {
    id: 7,
    name: "Cagrilintide 10mg",
    description: "Cagrilintide is an appetite suppressant peptide used in weight management protocols.",
    url: "https://simplepeptide.com/shop/cagrilintide-10mg/",
    productId: 1722,
    categories: ["Appetite Suppressant", "Weight Management"]
  },
  {
    id: 8,
    name: "CJC 1295 w/ DAC 5mg",
    description: "CJC 1295 with DAC is a growth hormone-releasing hormone analog promoting growth hormone secretion.",
    url: "https://simplepeptide.com/shop/cjc-1295-w-dac-5mg/",
    productId: 1719,
    categories: ["Growth Hormone", "Anti-Aging"]
  },
  {
    id: 9,
    name: "DSIP 10mg",
    description: "DSIP (Delta Sleep Inducing Peptide) helps improve sleep quality and reduce stress.",
    url: "https://simplepeptide.com/shop/dsip-10mg/",
    productId: 2004,
    categories: ["Sleep", "Stress Reduction"]
  },
  {
    id: 10,
    name: "Epitalon 10mg",
    description: "Epitalon is a peptide that regulates the pineal gland to promote anti-aging effects.",
    url: "https://simplepeptide.com/shop/epitalon-10mg/",
    productId: 31,
    categories: ["Anti-Aging", "Longevity"]
  },
  {
    id: 11,
    name: "HGH Fragment 176-191",
    description: "HGH Fragment 176-191 is a fat loss peptide that targets fat metabolism without affecting blood sugar levels.",
    url: "https://simplepeptide.com/shop/hgh-fragment-176-191/",
    productId: 1721,
    categories: ["Fat Loss", "Growth Hormone"]
  },
  {
    id: 12,
    name: "GHK-Cu 100mg",
    description: "GHK-Cu is a copper peptide used for skin regeneration and anti-aging purposes.",
    url: "https://simplepeptide.com/shop/ghk-cu-100mg/",
    productId: 32,
    categories: ["Skin Health", "Anti-Aging"]
  },
  {
    id: 13,
    name: "GHK-Cu + BPC 157 + TB-500 Blend",
    description: "A blend of peptides for comprehensive recovery, healing, and anti-inflammatory effects.",
    url: "https://simplepeptide.com/shop/ghk-cu-bpc-157-tb-500-blend-simple-peptide-peptides/",
    productId: 2631,
    categories: ["Healing", "Skin Health", "Recovery"]
  },
  {
    id: 14,
    name: "GHRP-2 5mg",
    description: "GHRP-2 is a growth hormone secretagogue that stimulates growth hormone release.",
    url: "https://simplepeptide.com/shop/ghrp-2-5mg/",
    productId: 2301,
    categories: ["Growth Hormone", "Anti-Aging"]
  },
  {
    id: 15,
    name: "GHRP-6 5mg",
    description: "GHRP-6 is a peptide that stimulates growth hormone release and helps in muscle building.",
    url: "https://simplepeptide.com/shop/ghrp-6-5mg/",
    productId: 2304,
    categories: ["Growth Hormone", "Muscle Building"]
  },
  {
    id: 16,
    name: "Glutathione",
    description: "Glutathione is a powerful antioxidant that helps reduce oxidative stress and improve skin health.",
    url: "https://simplepeptide.com/shop/glutathione/",
    productId: 33,
    categories: ["Antioxidant", "Skin Health"]
  },
  {
    id: 17,
    name: "HCG 5000iu",
    description: "HCG is used for hormonal balance and weight management.",
    url: "https://simplepeptide.com/shop/hcg-5000iu/",
    productId: 34,
    categories: ["Hormonal Balance", "Weight Management"]
  },
  {
    id: 18,
    name: "HMG 75iu",
    description: "HMG is used in fertility treatments and hormone regulation.",
    url: "https://simplepeptide.com/shop/hmg-75iu/",
    productId: 1714,
    categories: ["Fertility", "Hormonal Balance"]
  },
  {
    id: 19,
    name: "IGF LR3 1mg",
    description: "IGF LR3 promotes muscle growth and enhances recovery.",
    url: "https://simplepeptide.com/shop/igf-lr3-1mg/",
    productId: 35,
    categories: ["Muscle Building", "Recovery"]
  },
  {
    id: 20,
    name: "Insulin Syringes 10-Pack",
    description: "Sterile insulin syringes for precise dosing of peptides.",
    url: "https://simplepeptide.com/shop/insulin-syringes-10-pack/",
    productId: 36,
    categories: ["Accessories"]
  },
  {
    id: 21,
    name: "Ipamorelin",
    description: "Ipamorelin is a peptide that stimulates growth hormone release, promoting muscle growth and fat loss.",
    url: "https://simplepeptide.com/shop/ipamorelin/",
    productId: 4351,
    categories: ["Growth Hormone", "Fat Loss"]
  },
  {
    id: 22,
    name: "Ipamorelin + CJC 1295 No DAC 5mg+5mg",
    description: "A combination of Ipamorelin and CJC 1295 for enhanced growth hormone secretion.",
    url: "https://simplepeptide.com/shop/ipamorelin-cjc-1295-no-dac-5mg-5mg/",
    productId: 37,
    categories: ["Growth Hormone", "Anti-Aging"]
  },
  {
    id: 23,
    name: "Kisspeptin 10mg",
    description: "Kisspeptin plays a key role in fertility and the regulation of reproductive hormones.",
    url: "https://simplepeptide.com/shop/kisspeptin-10mg/",
    productId: 5941,
    categories: ["Fertility", "Hormonal Balance"]
  },
  {
    id: 24,
    name: "KPV 5mg",
    description: "KPV is an anti-inflammatory peptide used for healing and gut health.",
    url: "https://simplepeptide.com/shop/kpv-5mg/",
    productId: 7247,
    categories: ["Healing", "Anti-Inflammatory", "Gut Health"]
  },
  {
    id: 25,
    name: "Lipo-C 1ml",
    description: "Lipo-C injections aid in fat metabolism and energy production.",
    url: "https://simplepeptide.com/shop/lipo-c-1ml/",
    productId: 1718,
    categories: ["Fat Loss", "Energy"]
  },
  {
    id: 26,
    name: "Melanotan 10mg",
    description: "Melanotan is used for tanning and skin protection by stimulating melanin production.",
    url: "https://simplepeptide.com/shop/melanotan-10mg/",
    productId: 38,
    categories: ["Skin Health", "Tanning"]
  },
  {
    id: 27,
    name: "MGF 2mg",
    description: "MGF (Mechano Growth Factor) aids in muscle repair and growth after exercise.",
    url: "https://simplepeptide.com/shop/mgf-2mg/",
    productId: 5931,
    categories: ["Muscle Repair", "Growth Hormone"]
  },
  {
    id: 28,
    name: "MOTS-C 10mg",
    description: "MOTS-C is a mitochondrial peptide that supports energy metabolism and promotes longevity.",
    url: "https://simplepeptide.com/shop/mots-c-10mg/",
    productId: 40,
    categories: ["Energy", "Longevity"]
  },
  {
    id: 29,
    name: "NAD 500mg",
    description: "NAD is vital for cellular energy production and anti-aging processes.",
    url: "https://simplepeptide.com/shop/nad-500mg/",
    productId: 41,
    categories: ["Energy", "Anti-Aging"]
  },
  {
    id: 30,
    name: "Oxytocin 2mg",
    description: "Oxytocin is a peptide that supports emotional well-being and stress reduction.",
    url: "https://simplepeptide.com/shop/oxytocin-2mg/",
    productId: 2460,
    categories: ["Emotional Well-Being", "Stress Reduction"]
  },
  {
    id: 31,
    name: "PEG-MGF 2mg",
    description: "PEG-MGF is a variant of MGF that supports muscle growth and repair.",
    url: "https://simplepeptide.com/shop/peg-mgf-2mg/",
    productId: 4210,
    categories: ["Muscle Repair", "Muscle Building"]
  },
  {
    id: 32,
    name: "Pinealon 10mg",
    description: "Pinealon is used for cognitive enhancement and supporting brain health.",
    url: "https://simplepeptide.com/shop/pinealon-10mg/",
    productId: 960,
    categories: ["Cognitive Function", "Brain Health"]
  },
  {
    id: 33,
    name: "PT-141 10mg",
    description: "PT-141 is a peptide that promotes libido and sexual health.",
    url: "https://simplepeptide.com/shop/pt-141-10mg/",
    productId: 44,
    categories: ["Sexual Health"]
  },
  {
    id: 34,
    name: "Retatrutide 10mg",
    description: "Retatrutide is a multi-functional peptide used for weight management and metabolic health.",
    url: "https://simplepeptide.com/shop/retra-10mg/",
    productId: 45,
    categories: ["Weight Management", "Metabolism"]
  },
  {
    id: 35,
    name: "Retatrutide 20mg",
    description: "Retatrutide is a multi-functional peptide used for weight management and metabolic health.",
    url: "https://simplepeptide.com/shop/retatrutide-20mg/",
    productId: 9805,
    categories: ["Weight Management", "Metabolism"]
  },
  {
    id: 36,
    name: "Selank 5mg",
    description: "Selank is a nootropic peptide for stress reduction and cognitive enhancement.",
    url: "https://simplepeptide.com/shop/selank-5mg/",
    productId: 2226,
    categories: ["Stress Reduction", "Cognitive Function"]
  },
  {
    id: 37,
    name: "Semaglutide 10mg",
    description: "Semaglutide is a weight loss peptide that supports appetite control and metabolic health.",
    url: "https://simplepeptide.com/shop/sema-10mg/",
    productId: 46,
    categories: ["Weight Management", "Appetite Suppressant"]
  },
  {
    id: 38,
    name: "Semax 5mg",
    description: "Semax is a peptide for enhancing memory, focus, and cognitive performance.",
    url: "https://simplepeptide.com/shop/semax-5mg/",
    productId: 2495,
    categories: ["Cognitive Function", "Focus"]
  },
  {
    id: 39,
    name: "Sermorelin 5mg",
    description: "Sermorelin stimulates growth hormone production, supporting anti-aging and muscle growth.",
    url: "https://simplepeptide.com/shop/sermorelin-5mg/",
    productId: 47,
    categories: ["Growth Hormone", "Anti-Aging"]
  },
  {
    id: 40,
    name: "SLU-PP-332",
    description: "SLU-PP-332 is an experimental peptide for research purposes.",
    url: "https://simplepeptide.com/shop/slu-pp-332/",
    productId: 8007,
    categories: ["Research"]
  },
  {
    id: 41,
    name: "SS-31 10mg",
    description: "SS-31 is a peptide that targets mitochondrial health and reduces oxidative stress.",
    url: "https://simplepeptide.com/shop/ss-31-10mg/",
    productId: 48,
    categories: ["Mitochondrial Health", "Anti-Aging"]
  },
  {
    id: 42,
    name: "TB-500 5mg",
    description: "TB-500 is a synthetic peptide that promotes healing, recovery, and inflammation reduction.",
    url: "https://simplepeptide.com/shop/tb-500-5mg/",
    productId: 49,
    categories: ["Healing", "Recovery", "Anti-Inflammatory"]
  },
  {
    id: 43,
    name: "Tesamorelin 10mg",
    description: "Tesamorelin is a peptide for reducing visceral fat and promoting growth hormone secretion.",
    url: "https://simplepeptide.com/shop/tesamorelin-10mg/",
    productId: 51,
    categories: ["Fat Loss", "Growth Hormone"]
  },
  {
    id: 44,
    name: "Tesofensine",
    description: "Tesofensine is an experimental compound for appetite suppression and weight management.",
    url: "https://simplepeptide.com/shop/tesofensine/",
    productId: 52,
    categories: ["Appetite Suppressant", "Weight Management"]
  },
  {
    id: 45,
    name: "Thymosin Alpha-1 5mg",
    description: "Thymosin Alpha-1 boosts immune function and supports overall health.",
    url: "https://simplepeptide.com/shop/thymosin-alpha-1-5mg/",
    productId: 53,
    categories: ["Immune Support", "Overall Health"]
  },
  {
    id: 46,
    name: "Tirz 10mg",
    description: "Tirz supports metabolic health and weight loss through appetite control.",
    url: "https://simplepeptide.com/shop/tirz-10mg/",
    productId: 54,
    categories: ["Metabolism", "Weight Loss"]
  },
  {
    id: 47,
    name: "Tirz 20mg",
    description: "Tirz 20mg offers enhanced metabolic and appetite control benefits.",
    url: "https://simplepeptide.com/shop/tirz-20mg/",
    productId: 3807,
    categories: ["Metabolism", "Weight Loss"]
  },
  {
    id: 48,
    name: "Tirz 30mg",
    description: "Tirz 30mg provides maximum potency for weight loss and metabolic health.",
    url: "https://simplepeptide.com/shop/tirz-30mg/",
    productId: 2126,
    categories: ["Metabolism", "Weight Loss"]
  }
];
